<template>
  <div>
    <h3>Character Sheet Editor</h3>
    <div>{{msg}}</div>
  </div>
</template>
<script>

export default {
  name: 'CortexPlusCharacterSheet',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App - Cortex'
    }
  }
}
</script>
<style scoped>

</style>
